import { mapGetters } from 'vuex'

export const permissionMixin = {
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
  },
  methods: {
    getUserPermission(value) {
      return this.userData.permissions.includes(value)
    },
  },
}

export const _ = null
